import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { requireMenuOrRedirect } from '@/lib/auth/require-permission';

const PlatformsPage = lazy(() =>
  import('@/pages/ads/ad-platforms/platforms-page').then((m) => ({ default: m.PlatformsPage })),
);

export const Route = createFileRoute('/_app/ads/ad-platforms')({
  beforeLoad: requireMenuOrRedirect('menu:ads-admin:ad-platforms', '/ads/accounts'),
  component: () => (
    <Suspense fallback={<div>加载中…</div>}>
      <PlatformsPage />
    </Suspense>
  ),
});
